var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaymentKlarna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 40,
    viewBox: "0 0 85 47.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .klarna-cls-1 {\n        fill: #ffb3c7;\n      }\n\n      .klarna-cls-2 {\n        fill: #0a0b09;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "klarna-pink-Badge",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    className: "klarna-cls-1",
    width: 85,
    height: 47.887,
    rx: 4.321
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(8.561 16.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    className: "klarna-cls-2",
    d: "M69.378,12.115A2.087,2.087,0,1,0,71.412,14.2a2.06,2.06,0,0,0-2.033-2.086ZM62.69,10.5a2.936,2.936,0,1,0-2.935,2.856A2.9,2.9,0,0,0,62.69,10.5ZM62.7,4.95H65.94v11.1H62.7v-.71A5.578,5.578,0,0,1,59.49,16.36,5.785,5.785,0,0,1,53.781,10.5,5.785,5.785,0,0,1,59.49,4.643,5.577,5.577,0,0,1,62.7,5.661V4.95ZM36.78,6.4V4.951H33.464v11.1h3.324V10.869c0-1.749,1.847-2.689,3.129-2.689h.038V4.951A4,4,0,0,0,36.78,6.4ZM28.519,10.5a2.936,2.936,0,1,0-2.935,2.856A2.9,2.9,0,0,0,28.519,10.5ZM28.53,4.95h3.239v11.1H28.53v-.71a5.578,5.578,0,0,1-3.211,1.017A5.785,5.785,0,0,1,19.611,10.5a5.785,5.785,0,0,1,5.709-5.858A5.576,5.576,0,0,1,28.53,5.661V4.95Zm19.5-.3A3.894,3.894,0,0,0,44.689,6.2V4.951H41.464v11.1h3.265V10.218A2.311,2.311,0,0,1,47.16,7.7c1.424,0,2.242.873,2.242,2.492v5.857h3.235V8.993a4.33,4.33,0,0,0-4.611-4.341Zm-33.133,11.4h3.39V0h-3.39V16.052ZM0,16.057H3.59V0H0ZM12.556,0A12.944,12.944,0,0,1,8.884,9.113l4.962,6.944H9.412L4.02,8.511l1.392-1.07A9.3,9.3,0,0,0,9.043,0h3.513Z",
    transform: "translate(0 0)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaymentKlarna);
export default __webpack_public_path__ + "static/media/logo-payment-klarna.decf3caa.svg";
export { ForwardRef as ReactComponent };